import { createPortal } from "react-dom";
import "./TrekkinActionModal.css";

export default function TrekkinActionModal({ open, title, text, actions = [], cancelLabel, onClose, mark = "✓" }) {
  if (!open) return null;

  const modal = (
    <div
      className="tk-action-modal-backdrop"
      role="presentation"
      onPointerDown={(event) => {
        if (event.target === event.currentTarget) onClose?.();
      }}
    >
      <section className="tk-action-modal" role="dialog" aria-modal="true" aria-labelledby="tk-action-modal-title">
        <div className="tk-action-modal-mark" aria-hidden="true">{mark}</div>
        <h2 id="tk-action-modal-title" className="tk-action-modal-title">{title}</h2>
        <p className="tk-action-modal-text">{text}</p>
        <div className="tk-action-modal-actions">
          {actions.map((action) => (
            <button
              key={action.label}
              type="button"
              className={`tk-action-modal-button ${action.primary ? "is-primary" : ""}`}
              onClick={action.onClick}
            >
              {action.label}
            </button>
          ))}
          <button type="button" className="tk-action-modal-cancel" onClick={onClose}>{cancelLabel}</button>
        </div>
      </section>
    </div>
  );

  return typeof document !== "undefined" && document.body ? createPortal(modal, document.body) : modal;
}
